import type { Robot } from "./types";

export const ROBOTS: Robot[] = [
    {
        id: "5dd569ac-4d65-4b03-8bf9-e4929387be5b",
        name: "FORKLIFT-001",
        kind: "agv",
        manufacturer: "Linde",
        model: "L-MATIC",
        connectivity: "offline",
        type: "forklift",
        alarms: 0,
        health: "unknown",
        lifecycle: "planned",
        integration: "none",
    },
    {
        id: "c22c8e26-d8bc-4897-a6a7-0ed449c346e3",
        name: "TRACTOR-001",
        kind: "agv",
        connectivity: "offline",
        manufacturer: "MOVVO Robotics",
        model: "TA7 INT",
        type: "tugger",
        alarms: 0,
        health: "unknown",
        lifecycle: "active",
        integration: "simulation",
    },
    {
        id: "79629dc8-e880-4e94-93d8-74970701d2b4",
        name: "AGV-1203",
        kind: "agv",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "JBT",
        model: "JayBo Heavy Load",
        alarms: 0,
        health: "unknown",
        lifecycle: "commissioning",
        integration: "none",
    },
    {
        id: "23df604e-0af5-4574-9875-308fd5fc86dd",
        name: "OTT0-012",
        kind: "amr",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "OTTO",
        model: "1500",
        health: "unknown",
        availability: "available",
        lifecycle: "active",
        integration: "simulation",
        alarms: 0,
    },
    {
        id: "09f75a60-f03c-42f4-87d4-36237ce59551",
        name: "OTT0-013",
        kind: "amr",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "OTTO",
        model: "1500",
        health: "unknown",
        availability: "available",
        lifecycle: "active",
        integration: "simulation",
        alarms: 0,
    },
    {
        id: "adfcaa39-8aee-4712-91cc-450adac8678f",
        name: "OTT0-014",
        kind: "amr",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "OTTO",
        model: "1500",
        health: "unknown",
        availability: "available",
        lifecycle: "active",
        integration: "simulation",
        alarms: 0,
    },
    {
        id: "f49417db-91ee-4d01-98ce-9a8ea0de7bb7",
        name: "OTT0-015",
        kind: "amr",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "OTTO",
        model: "1500",
        health: "unknown",
        availability: "available",
        lifecycle: "active",
        integration: "simulation",
        alarms: 0,
    },
    {
        id: "98548b6a-eaf3-4b8b-9642-c94f276f2236",
        name: "OTT0-016",
        kind: "amr",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "OTTO",
        model: "1500",
        health: "unknown",
        availability: "available",
        lifecycle: "active",
        integration: "simulation",
        alarms: 0,
    },
    {
        id: "366b23cc-d0c7-4a3d-a5fc-fa105df5f5b7",
        name: "OTT0-017",
        kind: "amr",
        connectivity: "offline",
        type: "unit_load",
        manufacturer: "OTTO",
        model: "1500",
        health: "unknown",
        availability: "available",
        lifecycle: "active",
        integration: "simulation",
        alarms: 0,
    },
    {
        id: "a9e2c535-e633-4440-a64c-a4c410d3b5d6",
        name: "G2P-001",
        kind: "amr",
        manufacturer: "Geek+",
        model: "P800",
        connectivity: "offline",
        type: "cart",
        alarms: 1,
        battery: 2,
        charging: "discharging",
        availability: "paused",
        health: "critical",
        lifecycle: "maintenance",
        integration: "none",
        lastSeen: new Date(Date.now() - 48 * 3600 * 1000),
    },
    {
        id: "1a5f41fe-2510-4c18-a423-a19be15d51c4",
        name: "TRACTOR-002",
        kind: "agv",
        connectivity: "offline",
        manufacturer: "MOVVO Robotics",
        model: "TA7 INT",
        type: "tugger",
        alarms: 0,
        health: "unknown",
        lifecycle: "planned",
        integration: "none",
    },
];
